<template>
  <div class="case-detail-gene-mitomap-data-page col-block width-full" :style="{ flex: 1 }">
    <div class="data-container col-block width-full" v-for="(variant, vindex) in variants" :key="vindex">
      <div class="data-title-container row-block">
        <div class="data-title">{{ variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -' }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <div class="data-content-container col-block width-full">
        <div class="data-content-block col-block width-full" v-for="(optionGroup, gindex) in tableOptionGroups" :key="gindex">
          <div class="data-row-container col-block width-full">
            <div class="data-row row-block stretch">
              <div class="data-col col-block" v-for="(option, oindex) in optionGroup.options" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
                <div :style="{ flex: 1 }"></div>
                <div class="data-content" v-html="option.title"></div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </div>
            <div class="data-row row-block stretch">
              <div class="data-col col-block" v-for="(option, oindex) in optionGroup.options" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
                <div :style="{ flex: 1 }"></div>
                <div class="data-content" :style="option.color ? { color: option.color(variant) } : {}" v-html="option.value(variant) || option.empty || '- -'"></div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: 0 }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { defaultEmptyDisplay } from '../../constants/global/data'

export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    gene () {
      return this.param.gene
    },
    variants () {
      return this.param.variants
    },
    // static
    tableOptionGroups () {
      const mitomap = {
        title: this.$t('COMPONENT.caseDetail.geneMitomapData.table.mitomap.___title'),
        options: [
          {
            title: this.$t('COMPONENT.caseDetail.geneMitomapData.table.mitomap.title.___af'),
            value: variant => variant.mitomap_AF,
            color: null,
            width: '70px',
            position: 'center',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneMitomapData.table.mitomap.title.___heteroplasmy'),
            value: variant => variant.mitomap_heteroplasmy,
            color: null,
            width: '130px',
            position: 'center',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneMitomapData.table.mitomap.title.___homoplasmy'),
            value: variant => variant.mitomap_homoplasmy,
            color: null,
            width: '130px',
            position: 'center',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneMitomapData.table.mitomap.title.___diseaseStatus'),
            value: variant => variant.mitomap_DiseaseStatus,
            color: null,
            width: '250px',
            position: 'center',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneMitomapData.table.mitomap.title.___disease'),
            value: variant => variant.mitomap_Disease ? variant.mitomap_Disease.split('-/-').join(',<br>') : null,
            color: null,
            position: 'left',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneMitomapData.table.mitomap.title.___pubmedIDs'),
            value: variant => variant.mitomap_PubmedIDs ? variant.mitomap_PubmedIDs.split(',').join(',<br>') : null,
            color: null,
            width: '120px',
            position: 'center',
            empty: this.$t(defaultEmptyDisplay.empty)
          }
        ]
      }
      return [
        mitomap
      ].filter(x => x)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/caseDetail/geneMitomapData.vue